// extracted by mini-css-extract-plugin
export default {"dark":"iCqxj","light":"TKAUM"};